import { Helmet } from 'react-helmet';
import NewdanhmucsanphamDetail
  from 'src/components/newdanhmucsanpham-detail/NewdanhmucsanphamDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmucsanphamListToolbar from '../components/newdanhmucsanpham-detail/NewdanhmucsanphamToolbar';

const Newdanhmucsanpham = () => (
  <>
    <Helmet>
      <title>Danh mục sản phẩm</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmucsanphamListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmucsanphamDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmucsanpham;
